import { render, staticRenderFns } from "./ModalDialog-Delete.vue?vue&type=template&id=57969d36&"
import script from "./ModalDialog-Delete.vue?vue&type=script&lang=js&"
export * from "./ModalDialog-Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports